export default __webpack_public_path__ + "static/media/logo.cb7c65bb.svg";